/*global*/


var extension = {} ;
extension.name = "other-field" ;

//must run after fields
extension.mustRunAfter = ["fields"] ;

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var otherEls = Array.prototype.slice.apply(view.viewRootEl.querySelectorAll('[data-field-other]'));
        
        otherEls.forEach(function(otherEl){
            var selectField = view.viewRootEl.querySelector('[data-field-def="'+otherEl.getAttribute("data-field-def").replace(/_other$/, "")+'"]') ;
            
            if(selectField){
                function onChange(){
                    var selectValue = selectField.getValue() ;
                    if(selectValue === "OTHER"){
                        otherEl.style.display = "block";
                    }else{
                        otherEl.style.display = "none";
                    }
                }

                selectField.addEventListener("change", onChange) ;
                view.on("render", onChange) ;
            }
        });
    }) ;
} ;




module.exports = extension ;